module.exports = __webpack_public_path__ + "static/media/19.bd27c71e.png";